module.exports = __webpack_public_path__ + "static/media/hayfa.c8eff22c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/equipe/hayfa.png
// module id = 2270
// module chunks = 0